import React from 'react';
import Nbsp from '../components/Nbsp';
import FileEditBtn from './file_edit_btn';
import FileLogBtn from './file_log_btn';
import FilesList from './files_list';
import FilesDownloadBtn from './FilesDownloadBtn';

class FileBlock extends React.Component {

    constructor(props) {
        super(props);
        this.labelName = 'Файлы';
        this.state = {
            files: this.props.files,
            updateFilesList: (files) => {
                this.setState({files: files});
            },
        };
    }

    render() {
        const {monolitSettings} = this.props;
        return (
            <span>
                <label>{this.labelName}</label>
                <Nbsp/>
                <Nbsp/>
                <FileEditBtn
                    updateFilesList={this.state.updateFilesList}
                    files={this.state.files}
                    fieldName={this.props.fieldName}
                    tableId={this.props.tableId}
                    rowId={this.props.rowId}
                    title={this.props.title}
                    settings={this.props.settings}
                    monolitSettings={this.props.monolitSettings}
                />
                <Nbsp/>
                <FileLogBtn {...this.props} />
                <Nbsp/>
                <FilesDownloadBtn
                    fieldName={this.props.fieldName}
                    rowId={this.props.rowId}
                    tableId={this.props.tableId}
                    files={this.state.files} />
                <FilesList files={this.state.files} monolitSettings={monolitSettings} />
            </span>
        );
    }
}
export default FileBlock;
